import { Pagination, PaginationProps } from "@mui/material";
import { HTMLAttributes, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface PaginationElementProps extends PaginationProps {

}

export function Element({ ...rest }: PaginationElementProps) {
    return (
        <Pagination
            className={twMerge("", rest.className)}
            shape="rounded"
            variant="outlined"
            sx={{
                '.Mui-selected':{
                    backgroundColor: '#ED636E !important',
                    borderColor:'#ED636E',
                    color: 'white'
                }
            }}
            {...rest}
        />
    )
}